module.exports = __webpack_public_path__ + "media/images/icon__locked@3x-993cf43057903a6a7a4b47dfd580d7c6.png";